import { getCurrentOrg } from './getCurrentOrg';
import { AuthenticationProxiedService } from '../services';
import { AgentApiService } from '../services/agents-management';
import { TelecomApiService } from '../services/agents-management';
import type { UserOrganizationDto as Dto } from '../services';

export type UserOrganizationDto = Omit<Dto, 'roles'> & {
  roles?: Array<{
    id?: string;
    name?: string;
    permissions?: string[];
  }>;
};

export const getUserOrgs = () => {
  return AuthenticationProxiedService.getUserOrganizationsAuthUserOrganizationsGet() as Promise<{
    organizations: UserOrganizationDto[];
  }>;
};

export const getShortAgents = () => {
  return AgentApiService.getShortAgents(getCurrentOrg(), true);
};

export const getPhones = () => {
  return TelecomApiService.getOutboundPhoneNumbers(getCurrentOrg());
};
